import { Button, Divider, Group, Modal, Space, Text } from "@mantine/core";
import React from "react";

type ConfirmCreateDatesProps = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  updateBlockedDate: () => void;
};
export const ConfirmCreateBlockedDates: React.FC<ConfirmCreateDatesProps> = ({
  isOpen,
  setOpen,
  updateBlockedDate,
}) => (
  <Modal
    opened={isOpen}
    onClose={() => {
      setOpen(false);
    }}
    withCloseButton={false}
    size="lg"
    closeOnClickOutside={false}
    centered
  >
    <div style={{ padding: "0 20px 30px 20px" }}>
      <Text
        size="xl"
        style={{
          marginTop: "30px",
          fontSize: "18px",
          fontWeight: 700,
          lineHeight: "24.59px",
        }}
      >
        Block Company Limits
      </Text>

      <Text size="xs" weight={400} mt={12}>
        Your employees will not be able to take advances during this time
        period.
      </Text>

      <Text size="xs" weight={400} mt={28}>
        Are you sure you want to set your block dates?
      </Text>

      <Space h="md" />

      <Divider my="sm" />
      <Space h="md" />

      <Group spacing="xl" position="right">
        <Button
          variant="outline"
          style={{
            height: "40px",
            padding: "0 20px",

            width: "150px",
          }}
          onClick={() => setOpen(false)}
        >
          No, Don&apos;t Block
        </Button>

        <Button
          onClick={() => {
            updateBlockedDate();
            setOpen(false);
          }}
          style={{
            height: "40px",
            padding: "0 20px",
            width: "150px",
          }}
        >
          Yes, Block Dates
        </Button>
      </Group>
    </div>
  </Modal>
);
